import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getDashboardRoute } from '../utils/dashboardRoute';

export const RoleDashboardRedirect = () => {
  const { user } = useAuth();
  return <Navigate to={getDashboardRoute(user)} replace />;
};
